<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerList' }">合作方</el-breadcrumb-item>
                <el-breadcrumb-item>合作方{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleDetailsForm"
                        :label-position="labelPosition"
                        class="details_temp2023"
                    >
                        <el-form-item label="code：" prop="code">
                            <el-input
                                :disabled="type == 1"
                                clearable
                                v-model="ruleForm.code"
                                size="mini"
                                placeholder="请输入代码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="省份：" prop="province_rid">
                            <el-select
                                v-model="ruleForm.province_name"
                                placeholder="请选择省份"
                                clearable
                                @change="provinceChange"
                                filterable
                                size="mini"
                            >
                                <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="名称：" prop="name">
                            <el-input v-model="ruleForm.name" size="mini" clearable placeholder="请输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="城市：" prop="city_rid">
                            <el-select
                                v-model="ruleForm.city_name"
                                placeholder="请选择城市"
                                clearable
                                filterable
                                size="mini"
                                @change="cityChange"
                            >
                                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="业务范围：" prop="business_scope_code">
                            <vDropdown
                                model_key="business_scope_code"
                                model_name="请选择业务范围"
                                :model_value_default="ruleForm.business_scope_code"
                                request_uri="businessScopes"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="business_scope_code_ref"
                            ></vDropdown>
                        </el-form-item>

                        <el-form-item label="运营类型：" prop="operation_type_code">
                            <vDropdown
                                model_key="operation_type_code"
                                model_name="请选择运营类型"
                                :model_value_default="ruleForm.operation_type_code"
                                request_uri="operationTypes"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="operation_type_code_ref"
                            ></vDropdown>
                        </el-form-item>

                        <el-form-item label="业务类型：" prop="business_type_code">
                            <vDropdown
                                model_key="business_type_code"
                                model_name="请选择业务类型"
                                :model_value_default="ruleForm.business_type_code"
                                request_uri="businessTypes"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="business_type_code_ref"
                            ></vDropdown>
                        </el-form-item>

                        <el-form-item label="业务单元：" prop="business_unit_rid">
                            <vDropdown
                                model_key="business_unit_rid"
                                model_name="请选择业务单元"
                                :model_value_default="ruleForm.business_unit_rid"
                                request_uri="dropdownBusinessUnits"
                                select_value="rid"
                                @onDropChange="onDropChange"
                                ref="business_unit_rid_ref"
                            ></vDropdown>
                        </el-form-item>

                        <el-form-item label="上级名称：" prop="parent_name">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.parent_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入上级名称搜索"
                                :remote-method="remoteMethod"
                                :loading="parentLoading"
                                size="mini"
                                clearable
                                @change="parentChange"
                                :disabled="disabled"
                            >
                                <el-option v-for="item in parentOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地址：" prop="address">
                            <el-input v-model="ruleForm.address" size="mini" clearable placeholder="请输入地址"></el-input>
                        </el-form-item>
                        <el-form-item label="经度：" prop="longitude">
                            <el-input v-model="ruleForm.longitude" size="mini" clearable placeholder="请输入经度" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="纬度：" prop="latitude">
                            <el-input v-model="ruleForm.latitude" size="mini" clearable placeholder="请输入纬度" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="专属账户：" prop="dedicated_account_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.dedicated_account_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入专属账户搜索"
                                :remote-method="remoteAccountMethod"
                                :loading="accountLoading"
                                size="mini"
                                clearable
                                @change="accountchange"
                            >
                                <el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="SF代码：" prop="sf_code">
                            <el-input size="mini" v-model="ruleForm.sf_code" clearable placeholder="请输入SF代码" />
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input v-model="ruleForm.remark" clearable placeholder="请输入备注" />
                        </el-form-item>
                        <el-form-item label="PPAM默认计算类型：" prop="commodity_flow_applicable">
                            <vDropdown
                                model_key="commodity_flow_applicable"
                                model_name="请选择PPAM默认计算类型"
                                :model_value_default="ruleForm.commodity_flow_applicable"
                                request_uri="dropdownCommodityFlowApplicable"
                                select_value="value"
                                @onDropChange="onDropChange"
                                ref="commodity_flow_applicable_ref"
                            ></vDropdown>
                        </el-form-item>
                        <el-form-item label="人员：" prop="person_rid">
                            <vDropdown
                                model_key="person_rid"
                                model_name="请选择人员"
                                :model_value_default="ruleForm['person_rid']"
                                request_uri="dropdownPerson"
                                @onDropChange="onDropChange"
                                ref="person_rid"
                            ></vDropdown>
                        </el-form-item>
                        <!-- <el-form-item label="规划末结束日初始化：" prop="scheme_first_start_date_initial">
                            <el-date-picker
                                v-model="ruleForm.scheme_first_start_date_initial"
                                type="date"
                                placeholder="请选择规划末结束日初始化"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item> -->
                        <!-- <el-form-item label="规划首开始日：" prop="scheme_first_start_date" v-if="type == 1">
                            <div class="read_only">{{ ruleForm.scheme_first_start_date }}</div>
                        </el-form-item>
                        <el-form-item label="规划末结束日：" prop="scheme_last_end_date" v-if="type == 1">
                            <div class="read_only">{{ ruleForm.scheme_last_end_date }}</div>
                        </el-form-item> -->
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'partnerEdit',
    data() {
        return {
            accountOptions: [],
            accountLoading: false,
            disabled: false,
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            parentOptions: [], //上级名称
            parentLoading: false,
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            parentlist: [],
            states: [],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {},
            rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                business_scope_code: [{ required: true, message: '请选择业务范围', trigger: 'blur' }],
                business_type_code: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
                business_unit_rid: [{ required: true, message: '请选择业务单元', trigger: 'blur' }],
                person_rid: [{ required: false, message: '请选择人员', trigger: 'blur' }],
                operation_type_code: [{ required: true, message: '请选择运营类型', trigger: 'blur' }],
                commodity_flow_applicable: [{ required: true, message: '请选择PPAM默认计算类型', trigger: 'blur' }],
                province_rid: [{ required: true, message: '请选择省份', trigger: 'blur' }],
                city_rid: [{ required: true, message: '请选择城市', trigger: 'blur' }]
            },
            btnTitle: '',
            btnLoading: false
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        this.initFormData();

        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else if (this.type == 4) {
            this.disabled = true;
        }

        this.getProvinces(); //获取省份
        this.parentlist = this.states.map((item) => {
            return { value: `${item.rid}`, label: `${item.name}` };
        });
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        initFormData() {
            this.ruleForm = {
                code: '',
                name: '',
                province_name: '',
                city_name: '',
                scheme_first_start_date_initial: '',
                scheme_first_start_date: '',
                scheme_last_end_date: '',
                dedicated_account_rid: '',
                dedicated_account_name: '',
                scheme_first_start_date: '',
                scheme_last_end_date: '',
                sf_code: '',
                remark: '',
                business_scope_code: '',
                business_type_code: '',
                business_unit_rid: '',
                operation_type_code: '',
                province_rid: '',
                city_rid: '',
                address: '',
                latitude: '',
                longitude: '',
                created_at: '',
                created_by: '',
                updated_at: '',
                updated_by: '',
                main_contact_name: '',
                main_contact_rid: '',
                parent_name: this.$route.query.parent_name || '',
                parent_rid: this.$route.query.parent_rid || '',
                commodity_flow_applicable: 1,
                person_rid: ''
            };
        },
        onDropChange(key, value) {
            this.ruleForm[key] = value;
        },
        //账户改变联动框
        accountchange(val) {
            this.ruleForm.dedicated_account_rid = val;
        },
        //城市改变联动框
        cityChange(val) {
            this.ruleForm.city_rid = val;
            this.ruleForm.city_name = val;
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //省份改变请求当下省份下的城市
        provinceChange(val) {
            this.ruleForm.province_rid = val;
            this.cityOptions = [];
            if (val) {
                this.ruleForm.city_name = '';
                this.ruleForm.city_rid = '';
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            } else {
                this.ruleForm.city_rid = '';
                this.ruleForm.city_name = '';
                this.cityOptions = [];
            }
        },
        //账户名称远程搜索方法
        remoteAccountMethod(query) {
            if (query !== '') {
                this.accountLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.accountLoading = false;
                                this.accountOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.accountOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.accountLoading = false;
                this.accountOptions = [];
            }
        },
        //上级名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.parentLoading = false;
                                this.parentOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //上级名称联动框改变
        parentChange(value) {
            this.ruleForm.parent_rid = value;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/partnerList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .partnerDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        for (let i in this.ruleForm) {
                            this.ruleForm[i] = res.data[i] || '';
                        }
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            this.ruleForm.rid = this.rid;
            this.$api
                .partnerUpdate(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            this.$api
                .partnerInsert(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>